import $ from '../utils/jquery';

class MarqueeScroll {
	constructor( element, id ) {
		this.$element = $( element );
		this.$wrapper = this.$element.closest( '.marquee-wrapper' );
		this.$textWrapper = this.$element.find( '.text-wrapper' );
		this.isReverse = this.$wrapper.hasClass( 'marquee-reverse' );
		this.isActive = false;
		this.scrollDistance = 0;
		this.namespace = `.marquee-${ id }`;

		this.init();
	}

	init() {
		this.checkIfCentered();
		this.calculateDistances();
		this.bindEvents();
		this.update();
	}

	checkIfCentered() {
		const computedStyle = window.getComputedStyle( this.$element[ 0 ] );
		const textAlign = computedStyle.getPropertyValue( 'text-align' );

		// Marquee should only be active when text is NOT centered
		this.isActive = textAlign !== 'center';

		// Reset transform if not active
		if ( ! this.isActive ) {
			this.$textWrapper.css( 'transform', 'translateX(0)' );
		}
	}

	calculateDistances() {
		if ( ! this.isActive ) {
			return;
		}

		const viewportWidth = window.innerWidth;
		const textWidth = this.$textWrapper.outerWidth();

		if ( this.isReverse ) {
			// For reverse: text starts visible on the right, moves to the left edge
			// Start position: visible at flex-end (right side)
			// End position: text left edge at viewport left edge
			this.scrollDistance = viewportWidth - textWidth;
		} else {
			// For normal: text starts at left, moves to the right edge of screen
			// Start position: at left (translateX = 0)
			// End position: text right edge at viewport right edge
			this.scrollDistance = viewportWidth - textWidth;
		}
	}

	bindEvents() {
		$( window ).on( `scroll${ this.namespace }`, () => this.update() );
		$( window ).on( `resize${ this.namespace }`, () => this.onResize() );
	}

	onResize() {
		this.checkIfCentered();
		this.calculateDistances();
		this.update();
	}

	update() {
		if ( ! this.isActive ) {
			return;
		}

		const scrollY = window.scrollY;
		const viewportHeight = window.innerHeight;

		// Calculate when element's top is visible
		const elementTop = this.$wrapper.offset().top;
		const elementHeight = this.$wrapper.outerHeight();

		// Scroll range: from when element top enters viewport bottom to when element bottom leaves viewport top
		const scrollStart = elementTop - viewportHeight;
		const scrollEnd = elementTop + elementHeight;
		const scrollRange = scrollEnd - scrollStart;

		// Only animate once the top of the parent is visible
		if ( scrollY < scrollStart ) {
			// Element not yet visible - reset to start position
			this.setPosition( 0 );
			return;
		}

		if ( scrollY > scrollEnd ) {
			// Element has passed - stay at end position
			this.setPosition( 1 );
			return;
		}

		// Calculate progress (0 to 1)
		const progress = ( scrollY - scrollStart ) / scrollRange;
		this.setPosition( progress );
	}

	setPosition( progress ) {
		// Clamp progress between 0 and 1
		progress = Math.max( 0, Math.min( 1, progress ) );

		let translateX;

		if ( this.isReverse ) {
			// Reverse: move from right (0) to left (-scrollDistance)
			translateX = -( this.scrollDistance * progress );
		} else {
			// Normal: move from left (0) to right (scrollDistance)
			translateX = this.scrollDistance * progress;
		}

		this.$textWrapper.css( 'transform', `translateX(${ translateX }px)` );
	}

	destroy() {
		$( window ).off( `scroll${ this.namespace } resize${ this.namespace }` );
		this.$textWrapper.css( 'transform', '' );
	}
}

const marqueeInstances = [];

const init = () => {
	$( '.marquee-text' ).each( function( index ) {
		marqueeInstances.push( new MarqueeScroll( this, index ) );
	} );
};

export default () => {
	const $marquee = $( '#marquee' );

	if ( ! $marquee.length ) {
		return;
	}

	init();
};
